import { useEffect, useState } from "react";
import {
  classNames,
  formatDateWithTime,
  isReadOnlyUser,
} from "../../../shared/utility";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import WipOutgoingSubTable1 from "./outgoingSubtables/WipOutgoingSubTable1";
import TableLoadingSkeleton from "../../shared/TableLoadingSkeleton";
import TraceableLotNumber from "../../controls/TraceableLotNumber";

export default function OutgoingWipItemsTableComponent(props) {
  const {
    isEdit,
    loading,
    values,
    openSlideForManufacturedItemDetails,
    onAskDeleteWipOutputItem,
    openAddPriceGroupModal,
    setOutgoingSelectedItems,
    outgoingSelectedItems,
    calculateCostForWipOutgoingItems,
    fetchOutgoingRowDetails,
    outgoingLoadingRows,
    outgoingRowDetails,
    fetchOutgoingSubRowDetails,
    outgoingSubRowDetails,
    outgoingSubLoadingRows,
    setOutgoingRowDetails,
    setOutgoingSubRowDetails,
  } = props;

  const [expandedRows, setExpandedRows] = useState(null);
  const allowExpansion = () => {
    return true;
  };

  const getRowClassName = (data) => {
    if (!data.pricing_group) return "";

    const colorMap = {
      1: "bg-red-50",
      2: "bg-orange-50",
      3: "bg-emerald-50",
      4: "bg-yellow-50",
      5: "bg-lime-50",
      6: "bg-green-50",
      7: "bg-cyan-50",
      8: "bg-rose-50",
      9: "bg-violet-50",
      10: "bg-pink-50",
      11: "bg-purple-50",
      12: "bg-indigo-50",
      13: "bg-teal-50",
      14: "bg-amber-50",
      15: "bg-blue-50 ",
    };

    return colorMap[data.pricing_group] || "";
  };

  const onRowExpand = (event) => {
    const rowData = event.data;
    if (!outgoingRowDetails[rowData.unique_id]) {
      fetchOutgoingRowDetails(rowData);
    }
  };

  const rowExpansionTemplate = (data) => {
    return (
      <WipOutgoingSubTable1
        data={data}
        outgoingLoadingRows={outgoingLoadingRows}
        outgoingRowDetails={outgoingRowDetails}
        fetchOutgoingSubRowDetails={fetchOutgoingSubRowDetails}
        outgoingSubRowDetails={outgoingSubRowDetails}
        outgoingSubLoadingRows={outgoingSubLoadingRows}
        openSlideForManufacturedItemDetails={
          openSlideForManufacturedItemDetails
        }
        onAskDeleteWipOutputItem={onAskDeleteWipOutputItem}
      />
    );
  };

  const bodyProductName = (item) => {
    return (
      <p>
        {item.product_name} <br />
        {item.plu}
      </p>
    );
  };

  const bodyParentTotalWeight = (item) => {
    return <p>{item.total_weight_in_kg} kg</p>;
  };

  const bodyParentTotalPieces = (item) => {
    return <p>{item.total_pieces} pieces</p>;
  };

  const itemCostPercentage = (item) => {
    return <p>{Number(item.production_cost_percentage).toFixed(2)}%</p>;
  };

  const itemTotalCostInDollars = (item) => {
    return <p>${Number(item.total_cost).toFixed(2)}</p>;
  };

  const itemPricingGroup = (item) => {
    if (item.pricing_group_percentage == null) {
      return null;
    }
    return <p>{Number(item.pricing_group_percentage).toFixed(0)}%</p>;
  };

  const isReadOnly = isReadOnlyUser();

  return (
    <div className="flow-root">
      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 space-y-2">
          <div className="w-full flex">
            <h3 className="text-lg leading-6 font-medium text-gray-900 flex-grow">
              Outgoing items
            </h3>
            {!isReadOnly && (
              <button
                className={
                  isEdit
                    ? "rounded-md bg-cyan-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-cyan-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-700"
                    : "hidden"
                }
                onClick={() => {
                  openAddPriceGroupModal();
                  setExpandedRows(false);
                }}
              >
                Add price group
              </button>
            )}
            <button
              className={
                isEdit
                  ? "rounded-md bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-700 ml-2"
                  : "hidden"
              }
              onClick={() => {
                calculateCostForWipOutgoingItems();
                setExpandedRows(false);
                setOutgoingRowDetails({});
                setOutgoingSubRowDetails({});
              }}
            >
              Calculate cost
            </button>
          </div>
          {loading ? (
            <TableLoadingSkeleton rows={5} columns={4} />
          ) : (
            <div className="overflow-hidden card-custom bg-white">
              <DataTable
                value={values.outgoing_items}
                expandedRows={expandedRows}
                onRowToggle={(e) => {
                  setExpandedRows(e.data);
                }}
                onRowExpand={onRowExpand}
                rowExpansionTemplate={rowExpansionTemplate}
                dataKey="unique_id"
                tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm wip-outgoing-items-table"
                cellClassName="p-2 border-1-bottom-gray text-sm"
                rowClassName={getRowClassName}
                selectionMode="checkbox"
                selection={outgoingSelectedItems}
                onSelectionChange={(e) => setOutgoingSelectedItems(e.value)}
              >
                <Column
                  selectionMode="multiple"
                  headerStyle={{ width: "1px" }}
                ></Column>
                <Column
                  header="Product Name"
                  body={bodyProductName}
                  style={{ width: "25%" }}
                />
                <Column
                  header="Lot Number"
                  body={(item) => (
                    <TraceableLotNumber
                      lotNumber={item.lot_number}
                      traceType="manufactured"
                    />
                  )}
                  style={{ width: "15%" }}
                />
                <Column
                  header="Carton Count"
                  field="carton_count"
                  style={{ textAlign: "right" }}
                />
                <Column
                  header="Total Weight (kg)"
                  body={bodyParentTotalWeight}
                  style={{ textAlign: "right" }}
                />
                <Column
                  header="Total Pieces"
                  body={bodyParentTotalPieces}
                  style={{ textAlign: "right" }}
                />
                <Column
                  header="Cost %"
                  body={itemCostPercentage}
                  style={{ textAlign: "right" }}
                />
                <Column
                  header="Cost $"
                  body={itemTotalCostInDollars}
                  style={{ textAlign: "right" }}
                />
                <Column
                  header="Pricing Group %"
                  body={itemPricingGroup}
                  style={{ textAlign: "center" }}
                />
                <Column expander={allowExpansion} style={{ width: "6%" }} />
              </DataTable>
              {values.outgoing_info ? (
                <div className="p-4 space-y-3">
                  <div className="flex justify-end gap-4">
                    <p className="text-md font-bold">
                      Total cartons: {values.outgoing_info.carton_count}
                    </p>
                    <p>
                      Total weight: {values.outgoing_info.total_weight_in_kg} kg
                    </p>
                    <p>
                      Total pieces: {values.outgoing_info.total_pieces} pieces
                    </p>
                  </div>
                  <div className="flex justify-end gap-4">
                    <p
                      className={classNames(
                        values.outgoing_info.total_cost_percentage > 100
                          ? "text-red-600"
                          : parseFloat(
                                values.outgoing_info.total_cost_percentage,
                              ) === parseFloat(100)
                            ? "text-green-600"
                            : null,
                        "text-md font-bold",
                      )}
                    >
                      Total cost percentage:{" "}
                      {Number(
                        values.outgoing_info.total_cost_percentage,
                      ).toFixed(2)}
                      %
                    </p>
                    <p>Total cost: ${values.outgoing_info.total_cost}</p>
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
